// Response object for GET /category
// https://docs.opendota.com/#category/categories%2Fpaths%2F~1categories%2Fget

import React from "react";
import { FormattedMessage } from "react-intl";

export const enum CategoryType {
  "DEFAULT" = "default",
  "GENRE" = "genre",
  "TERRITORY" = "territory"
}

export const enum FlagType {
  "NONE" = "none",
  "CLIENT_FILTER" = "client_filter",
  "TERRITORY" = "territory",
}

export const CategoryTypeOptions = [
  {
    value: CategoryType.DEFAULT,
    label: <FormattedMessage id="app.default" defaultMessage={`Default`} />
  },
  {
    value: CategoryType.GENRE,
    label: <FormattedMessage id="app.genre" defaultMessage={`genre`} />
  },
  {
    value: CategoryType.TERRITORY,
    label: <FormattedMessage id="app.territory" defaultMessage={`territory`} />
  }
];

export interface Category extends ApiResponse {
  id: string;
  short_id: string;
  title: string;
  slug: string;
  type: CategoryType;
  parent_category_id: string;
  cover_image_file: string | null;
  thumbnail_image_file_id: string | null;
  body: string;
  created_at: string;
  modified_at: string;
  flag: FlagType;
  iran_access: boolean;
  compact_header: boolean;
}

export type ApiResponse = Record<string, any>;

export interface CategoriesState {
  readonly loading: boolean;
  readonly data: Category[];
  readonly errors?: string;
  readonly count: number;
}
